import { useState, useCallback } from 'react';
import { updateVersionPreference } from '../v2/api/userpreference';

export const useVersionSwitcher = () => {
  const [isLoading, setIsLoading] = useState(false);
  
  const currentVersion = localStorage.getItem('currentappversion') || 'v1';
  const isV2Mode = currentVersion === 'v2';
  const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';
  
  const toggleVersion = useCallback(async () => {
    setIsLoading(true);
    
    const newVersion = isV2Mode ? 'v1' : 'v2';
    const versionType = newVersion === 'v1' ? 1 : 2;
    
    try {
      await updateVersionPreference(versionType);
      localStorage.setItem('currentappversion', newVersion);
    } catch (e) {
      console.log('API failed, switching locally');
      localStorage.setItem('currentappversion', newVersion);
    }
    
    const newUrl = newVersion === 'v1' 
      ? lang === 'en-us' ? `/dashboard/activities?lang=en-us` : `/instrumentbrada/aktiviteter?lang=sv-se`
      : `/v2/dashboard?lang=${lang}`;
    
    window.location.href = newUrl;
  }, [isV2Mode, lang]);
  
  return {
    currentVersion,
    isV2Mode,
    toggleVersion,
    isLoading
  };
};